import { type MouseEvent, useMemo, useState } from 'react';
import { useIntl } from 'react-intl';
import DropdownMenu from '@alltrails/denali/components/DropdownMenu';
import IconButton from '@alltrails/denali/components/IconButton';
import Overflow from '@alltrails/denali/icons/Overflow';
import styles from './EditOptions.module.scss';

type EditOptionsProps = {
  className?: string;
  onAddToRouteClick?: () => void;
  onEditClick: () => void;
  onDeleteClick: (e?: MouseEvent<HTMLElement>) => void;
  variant?: 'ghost' | 'secondary';
};

const EditOptions = ({ className, onAddToRouteClick, onEditClick, onDeleteClick, variant = 'secondary' }: EditOptionsProps) => {
  const intl = useIntl();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const options = useMemo(() => {
    return [
      ...(onAddToRouteClick
        ? [
            {
              title: intl.formatMessage({ defaultMessage: 'Add to route' }),
              onClick: onAddToRouteClick
            }
          ]
        : []),
      {
        title: intl.formatMessage({ defaultMessage: 'Edit' }),
        onClick: onEditClick
      },
      {
        className: styles.deleteOption,
        title: intl.formatMessage({ defaultMessage: 'Delete' }),
        onClick: onDeleteClick
      }
    ];
  }, [intl, onAddToRouteClick, onEditClick, onDeleteClick]);

  return (
    <DropdownMenu
      anchor={
        <IconButton
          className={className}
          icon={{ Component: Overflow }}
          onClick={() => setIsDropdownOpen(isOpen => !isOpen)}
          size="sm"
          title={intl.formatMessage({ defaultMessage: 'Options' })}
          variant={variant}
        />
      }
      onCloseRequest={() => setIsDropdownOpen(false)}
      isOpen={isDropdownOpen}
      options={options}
      placement="bottom-end"
    />
  );
};

export default EditOptions;
